<div style="color: #D9D9D9; justify-content: start" [style.padding-top]="paddingTop" [style.height]="height"
  class="flex-center flex-column gap-200 flex-grow-1">
  <app-st-icon class="empty-main-icon" [name]="icon"></app-st-icon>
  <span class="text-header-24">No hay {{object}}.</span>
  <span *ngIf="!hideBtn" class="text-label-14">{{text}}</span>
  <span *ngIf="customText" class="text-label-14" style="max-width: 300px;">{{customText}}</span>


  @if(!hideBtn) {
    @if (!isSplitBtn) {
      <button class="flex-center gap-075" nzShape="round" nzSize="large" nz-button nzType="primary"
              (click)="emitBtnPressEvent()">
        <app-st-icon class="text-btn-16 prefix" [bold]="true" [name]="btnIcon"></app-st-icon>
        <span class="text-btn-14">{{btnText}}</span>
      </button>
    } @else {
      <app-split-btn [primaryIcon]="'add'" style="margin-top: 15px"
                     [secondaryIcon]="'arrow_drop_down'" [text]="'Crear'"
                     (primaryActionEvent)="emitBtnPressEvent()"
                     (secondaryActionEvent)="emitSecondaryBtnPressEvent()"
      ></app-split-btn>
    }
  }
</div>
